import type { WorldFeature } from './types';
import { TERRAIN_FEATURES } from './terrain/index';
import { STREETSCAPE_FEATURES } from './streetscape/index';
import { FABRIC_FEATURES } from './fabric/index';
import { HARBOUR_FEATURES } from './harbour/index';
import { COUNTRY_FEATURES } from './country/index';
import { LIFE_FEATURES } from './life/index';

export function getAllFeatures(): readonly WorldFeature[] {
  return [
    ...TERRAIN_FEATURES,
    ...STREETSCAPE_FEATURES,
    ...FABRIC_FEATURES,
    ...HARBOUR_FEATURES,
    ...COUNTRY_FEATURES,
    ...LIFE_FEATURES,
  ];
}
